import { createContext } from "react";
// src/contexts/layout.ts
const LayoutContext = createContext(null);
export { LayoutContext };

//# sourceMappingURL=layout.js.map